// extracted by mini-css-extract-plugin
export default {"contain":"footer-edit-request_contain__QZAqE","text__path":"footer-edit-request_text__path__OpcKu","buttons":"footer-edit-request_buttons__OtKu3"};